import { ChevronLeft } from '@medusajs/icons';
import { clx } from '@medusajs/ui';
import type { ReactNode } from 'react';

interface ConfirmModalTabItemProps {
  isActive: boolean;
  children: ReactNode;
}

const ConfirmModalTabItem = ({
  isActive,
  children,
}: ConfirmModalTabItemProps) => (
  <div
    className={clx('text-grey-10 flex-1', {
      'text-black-20': isActive,
    })}
  >
    <div className="mb-2">{children}</div>
    <div
      className={clx('bg-grey-10 min-h-1 w-full rounded-full', {
        'bg-black-20': isActive,
      })}
    />
  </div>
);

interface ConfirmModalTabsProps {
  showPrev: boolean;
  onClickPrev: () => void;
  children?: ReactNode;
}

const ConfirmModalTabs = ({
  showPrev,
  onClickPrev,
  children,
}: ConfirmModalTabsProps) => {
  return (
    <>
      {showPrev && (
        <div className="mb-2 min-h-[20px]">
          <ChevronLeft className="cursor-pointer" onClick={onClickPrev} />
        </div>
      )}
      <div className="my-2 flex gap-2">{children}</div>
    </>
  );
};

ConfirmModalTabs.Item = ConfirmModalTabItem;

export default ConfirmModalTabs;
